export default (function () {
    // 仅有四川地区
    const cityBmArr = [
        510104,
        510105,
        510106,
        510107,
        510108,
        510112,
        510113,
        510114,
        510115,
        510116,
        510117,
        510121,
        510129,
        510131,
        510132,
        510181,
        510182,
        510183,
        510184,
        510185,
        510302,
        510303,
        510304,
        510311,
        510321,
        510322,
        510402,
        510403,
        510411,
        510421,
        510422,
        510502,
        510503,
        510504,
        510521,
        510522,
        510524,
        510525,
        510603,
        510604,
        510623,
        510681,
        510682,
        510683,
        510703,
        510704,
        510705,
        510722,
        510723,
        510725,
        510726,
        510727,
        510781,
        510802,
        510811,
        510812,
        510821,
        510822,
        510823,
        510824,
        510903,
        510904,
        510921,
        510923,
        510981,
        511002,
        511011,
        511024,
        511025,
        511083,
        511102,
        511111,
        511112,
        511113,
        511123,
        511124,
        511126,
        511129,
        511132,
        511133,
        511181,
        511302,
        511303,
        511304,
        511321,
        511322,
        511323,
        511324,
        511325,
        511381,
        511402,
        511403,
        511421,
        511423,
        511424,
        511425,
        511502,
        511503,
        511504,
        511523,
        511524,
        511525,
        511526,
        511527,
        511528,
        511529,
        511602,
        511603,
        511621,
        511622,
        511623,
        511681,
        511702,
        511703,
        511722,
        511723,
        511724,
        511725,
        511781,
        511802,
        511803,
        511822,
        511823,
        511824,
        511825,
        511826,
        511827,
        511902,
        511903,
        511921,
        511922,
        511923,
        512002,
        512021,
        512022,
        513201,
        513221,
        513222,
        513223,
        513224,
        513225,
        513226,
        513227,
        513228,
        513230,
        513231,
        513232,
        513233,
        513301,
        513322,
        513323,
        513324,
        513325,
        513326,
        513327,
        513328,
        513329,
        513330,
        513331,
        513332,
        513333,
        513334,
        513335,
        513336,
        513337,
        513338,
        513401,
        513422,
        513423,
        513424,
        513425,
        513426,
        513427,
        513428,
        513429,
        513430,
        513431,
        513432,
        513433,
        513434,
        513435,
        513436,
        513437,
    ]
    return cityBmArr
})()